module.exports = __webpack_public_path__ + "images/plan_target_tip2.8bcc8aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plan/plan_target_tip2.png
// module id = 210
// module chunks = 33